import React from 'react';
import Button from '@components/atoms/Button';

const PaginationButton = ({
  value = ``,
  isActive = false,
  onClick = () => {}
}) => (
  <Button
    size="ellipsedSmall"
    textColor={isActive ? `colours.colour-1` : `white`}
    color={isActive ? `colours.colour-1` : `white`}
    bgColor={isActive ? `white` : `colours.colour-1-muted`}
    px="0 !important"
    width={{ base: 12, md: 14 }}
    // height={{ base: 12, md: 14 }}
    _hover={
      isActive
        ? {
            cursor: `default`
          }
        : {
            textColor: `colours.colour-1`,
            color: `colours.colour-1`,
            bg: `white`
          }
    }
    _focus={
      isActive
        ? {
            cursor: `default`
          }
        : {
            textColor: `colours.colour-1`,
            color: `colours.colour-1`,
            bg: `white`
          }
    }
    onClick={onClick}>
    {value}
  </Button>
);

export default PaginationButton;
